import { motion } from "framer-motion";
import {
  fadeUp,
  staggerContainer,
  viewportOnce,
} from "./Animations";
import { program } from "@/lib/program-data";

export default function StatsRankings() {
  return (
    <section className="w-full bg-white">

      {/* =====================================================
          TOP PROGRAM HIGHLIGHTS
      ====================================================== */}
      <div className="bg-white py-10 sm:py-12 lg:py-14">
        <div className="mx-auto max-w-6xl px-6 sm:px-10 lg:px-12">

          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={viewportOnce}
            variants={staggerContainer}
            className="
              grid
              grid-cols-1
              gap-6
              sm:grid-cols-3
              sm:gap-0
            "
          >
            {/* 6 Months in India */}
            <motion.div
              variants={fadeUp}
              className="
                flex
                items-center
                justify-center
                gap-3
                px-4
                py-5
                text-center
                sm:border-r
                sm:border-[#D5D9DF]
                sm:border-r-2
              "
            >
              <svg
                className="h-6 w-6 shrink-0 text-[#12539F]"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z" />
                <circle cx="12" cy="10" r="2.5" />
              </svg>

              <p className="text-base font-semibold text-[#111827] sm:text-lg lg:text-xl">
                6 Months in India
              </p>
            </motion.div>

            {/* 2 Credentials, 1 Pathway */}
            <motion.div
              variants={fadeUp}
              className="
                flex
                items-center
                justify-center
                gap-3
                px-4
                py-5
                text-center
                sm:border-[#D5D9DF]
                sm:border-r-2
              "
            >
              <svg
                className="h-6 w-6 shrink-0 text-[#12539F]"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M22 10 12 5 2 10l10 5 10-5Z" />
                <path d="M6 12.5V17c3.5 2.5 8.5 2.5 12 0v-4.5" />
                <path d="M22 10v6" />
              </svg>

              <p className="text-base font-semibold text-[#111827] sm:text-lg lg:text-xl">
                2 Credentials, 1 Pathway
              </p>
            </motion.div>

            {/* Visa Acceptance Rate */}
            <motion.div
              variants={fadeUp}
              className="
                flex
                items-center
                justify-center
                gap-3
                px-4
                py-5
                text-center
              "
            >
              <svg
                className="h-6 w-6 shrink-0 text-[#12539F]"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 3 20 6v5c0 5.25-3.4 8.75-8 10-4.6-1.25-8-4.75-8-10V6l8-3Z" />
                <path d="m9 12 2 2 4-4" />
              </svg>

              <p className="text-base font-semibold text-[#111827] sm:text-lg lg:text-xl">
                80-85% Visa Acceptance Rate
              </p>
            </motion.div>
          </motion.div>
        </div>
      </div>


      {/* =====================================================
          RANKINGS — DARK PREMIUM SECTION
      ====================================================== */}
      <div className="relative isolate overflow-hidden bg-[#0B0C0F] py-8">

        {/* =================================================
            LARGE ORANGE AMBIENT BLOB — TOP RIGHT
        ================================================== */}
        <div
          className="
            pointer-events-none
            absolute
            -right-[180px]
            -top-[220px]
            h-[520px]
            w-[620px]
            rounded-full
            bg-[#EDA12E]/20
            blur-[110px]
          "
        />

        {/* Stronger inner glow */}
        {/* <div
          className="
            pointer-events-none
            absolute
            right-[20px]
            -top-[100px]
            h-[300px]
            w-[360px]
            rounded-full
            bg-[#EDA12E]/10
            blur-[70px]
          "
        /> */}

        {/* =================================================
            SMALL ORANGE BLOB — BOTTOM LEFT
        ================================================== */}
        {/* <div
          className="
            pointer-events-none
            absolute
            -bottom-[180px]
            -left-[180px]
            h-[420px]
            w-[420px]
            rounded-full
            bg-[#EDA12E]/[0.07]
            blur-[100px]
          "
        /> */}

        {/* =================================================
            CURVED ORANGE OUTLINE
        ================================================== */}
        {/* <div
          className="
            pointer-events-none
            absolute
            -right-[180px]
            -top-[170px]
            h-[500px]
            w-[500px]
            rounded-full
            border-[2px]
            border-[#EDA12E]/[0.10]
          "
        /> */}

        {/* <div
          className="
            pointer-events-none
            absolute
            -right-[120px]
            -top-[110px]
            h-[380px]
            w-[380px]
            rounded-full
            border
            border-[#EDA12E]/[0.06]
          "
        /> */}

        {/* =================================================
            SUBTLE RADIAL DOT / GRID TEXTURE
        ================================================== */}
        {/* <div
          className="
            pointer-events-none
            absolute
            inset-0
            opacity-30
          "
          style={{
            backgroundImage:
              "radial-gradient(rgba(255,255,255,0.10) 1px, transparent 1px)",
            backgroundSize: "28px 28px",
            maskImage:
              "linear-gradient(to bottom, black 0%, transparent 65%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, black 0%, transparent 65%)",
          }}
        /> */}

        {/* =================================================
            TOP EDGE ACCENT
        ================================================== */}
        {/* <div
          className="
            pointer-events-none
            absolute
            left-1/2
            top-0
            h-px
            w-[70%]
            -translate-x-1/2
            bg-gradient-to-r
            from-transparent
            via-[#EDA12E]/30
            to-transparent
          "
        /> */}

        {/* CONTENT */}
        <div className="relative mx-auto max-w-7xl px-6 sm:px-10 lg:px-12">

{/* =================================================
    RANKINGS — EDITORIAL STYLE
================================================= */}
<motion.div
  initial="hidden"
  whileInView="visible"
  viewport={viewportOnce}
  variants={staggerContainer}
  className="
    grid
    grid-cols-1
    sm:grid-cols-3
    divide-y
    divide-white/[0.12]
    sm:divide-x
    sm:divide-y-0
  "
>
  {/* =================================================
{/* =================================================
    COLUMN 1 — #1 + #22 / BEST SALARIES
================================================= */}
<motion.div
  variants={fadeUp}
  className="
    flex
    flex-col
    items-center
    justify-center
    px-6
    py-8
    text-center
    sm:px-8
    sm:py-8
    lg:px-8
  "
>
  {/* #1 */}
  <div className="flex flex-col items-center">
    <p
      className="
        font-heading
        text-4xl
        leading-none
        tracking-[-0.035em]
        text-white
        sm:text-[42px]
        lg:text-[48px]
      "
    >
      {program.rankings.items[0].value}
    </p>

    <p
      className="
        mt-2
        text-[11px]
        font-medium
        leading-tight
        text-white/55
        sm:text-xs
      "
    >
      in Illinois
    </p>
  </div>

  {/* #22 */}
  <div className="mt-7 flex flex-col items-center">
    <p
      className="
        font-heading
        text-4xl
        leading-none
        tracking-[-0.035em]
        text-white
        sm:text-[42px]
        lg:text-[48px]
      "
    >
      {program.rankings.items[1].value}
    </p>

    <p
      className="
        mt-2
        text-[11px]
        font-medium
        leading-tight
        text-white/55
        sm:text-xs
      "
    >
      in the U.S.
    </p>
  </div>

  {/* Shared Ranking Title */}
  <p
    className="
      mt-6
      max-w-[280px]
      text-sm
      font-semibold
      leading-snug
      text-white
      sm:text-[15px]
    "
  >
    Best Salaries of Graduates
  </p>

  {/* Shared Source */}
  <p
    className="
      mt-4
      max-w-[280px]
      text-[9px]
      font-medium
      uppercase
      leading-relaxed
      tracking-[0.18em]
      text-white/35
      sm:text-[10px]
    "
  >
    {program.rankings.items[0].source} ({program.rankings.items[0].year})
  </p>
</motion.div>

  {/* =================================================
      COLUMN 2 — TOP 100
  ================================================== */}
<motion.div
  variants={fadeUp}
  className="
    flex
    min-h-[280px]
    flex-col
    items-center
    justify-center
    px-6
    py-10
    text-center
    sm:min-h-0
    sm:px-8
    sm:py-8
    lg:px-10
  "
>
  {(() => {
    const r = program.rankings.items[2];

    return (
      <>
        {/* Top 100 */}
        <p
          className="
            font-heading
            text-5xl
            leading-none
            tracking-[-0.04em]
            text-white
            sm:text-[52px]
            lg:text-[58px]
          "
        >
          {r.value}
        </p>

        <p
          className="
            mt-2
            text-[11px]
            font-medium
            leading-tight
            text-white/55
            sm:text-xs
          "
        >
          in the United States
        </p>

        {/* #91 Nationwide */}
        <p
          className="
            mt-6
            font-heading
            text-4xl
            leading-none
            tracking-[-0.035em]
            text-white
            sm:text-[42px]
            lg:text-[48px]
          "
        >
          #91
        </p>

        <p
          className="
            mt-2
            text-[11px]
            font-medium
            leading-tight
            text-white/55
            sm:text-xs
          "
        >
          nationwide
        </p>

        {/* Ranking title */}
        <p
          className="
            mt-5
            max-w-[280px]
            text-sm
            font-semibold
            leading-snug
            text-white
            sm:text-[15px]
          "
        >
          {r.label}
        </p>

        {/* Source */}
        <p
          className="
            mt-4
            max-w-[280px]
            text-[9px]
            font-medium
            uppercase
            leading-relaxed
            tracking-[0.18em]
            text-white/35
            sm:text-[10px]
          "
        >
          {r.source} ({r.year})
        </p>
      </>
    );
  })()}
</motion.div>

  {/* =================================================
      COLUMN 3 — 1 OF 5
  ================================================== */}
  <motion.div
    variants={fadeUp}
    className="
      flex
      min-h-[280px]
      flex-col
      items-center
      justify-center
      px-6
      py-10
      text-center
      sm:px-8
      lg:px-10
    "
  >
    {(() => {
      const r = program.rankings.items[3];

      return (
        <>
          {/* Ranking number */}
          <p
            className="
              font-heading
              text-5xl
              leading-none
              tracking-[-0.04em]
              text-white
              sm:text-[52px]
              lg:text-[58px]
            "
          >
            {r.value}
          </p>

          {/* Descriptor */}
          <p
            className="
              mt-2
              text-[11px]
              font-medium
              leading-tight
              text-white/55
              sm:text-xs
            "
          >
            STEM-based institutions
          </p>

          {/* Ranking title */}
          <p
            className="
              mt-5
              max-w-[300px]
              text-sm
              font-semibold
              leading-snug
              text-white
              sm:text-[15px]
            "
          >
            {r.label}
          </p>

          {/* Source */}
          <p
            className="
              mt-4
              max-w-[300px]
              text-[9px]
              font-medium
              uppercase
              leading-relaxed
              tracking-[0.18em]
              text-white/35
              sm:text-[10px]
            "
          >
            {r.source} ({r.year})
          </p>
        </>
      );
    })()}
  </motion.div>
</motion.div>

        </div>
      </div>

    </section>
  );
}